import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderRefreshOutline = createIcon({
  displayName: 'FolderRefreshOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M19,6.94h-6.471c-0.331,0 -0.641,-0.164 -0.827,-0.438l-1.405,-2.065c-0.186,-0.273 -0.495,-0.437 -0.826,-0.437h-4.471c-1.105,0 -2,0.895 -2,2v12c0,1.105 0.895,2 2,2h14c1.105,0 2,-0.895 2,-2v-9.06c0,-1.104 -0.895,-2 -2,-2Z"></path>
        <path d="M15.025,13c0.159,0.945 -0.118,1.947 -0.848,2.677c-0.913,0.913 -2.257,1.131 -3.378,0.657"></path>
        <path d="M13.201,10.666c-1.121,-0.474 -2.464,-0.257 -3.378,0.657c-0.73,0.73 -1.007,1.732 -0.848,2.677"></path>
        <path d="M12.673,9.819l0.688,0.688l-0.688,0.687"></path>
        <path d="M11.327,15.806l-0.688,0.687l0.688,0.688"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24v-24Z"></path>
    </>
  ),
})

const FolderRefresh: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderRefreshTwoTone} {...props} />

  return <CustomIcon as={FolderRefreshOutline} {...props} />
}

export default memo(FolderRefresh)
